import { Injectable } from '@angular/core';
import { FicheMiseEnPlace } from '../model/fiche-mise-en-place';
import { RestClientService } from '../../rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class FicheMiseEnPlaceService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getFicheMiseEnPlaceByrequestId(requestId) {
      return this._restClientService.load<FicheMiseEnPlace>('fiche-mise-en-place/fiche-mise-en-place-by-requestid/'+requestId);
    }
      
    putFicheMiseEnPlace(ficheMiseEnPlace: FicheMiseEnPlace) {
      return this._restClientService.put<void>('fiche-mise-en-place/update-fiche-mise-en-place', ficheMiseEnPlace);
    }
      
}      

    